export default __webpack_public_path__ + "static/media/3_col_5.470fb018.jpg";